import React, { useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  CircularProgress,
  Grid,
  Checkbox,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DeleteIcon from "@material-ui/icons/Delete";
import { getArticleById } from "../../services/articles.service";
import { Spinner, Layout } from "../../components";
import { Categorys } from "../../categorys/categorys";
import { Users } from "../../users/users";
import { getPolls } from "../../services/polls.service";
import { InsertMedia } from "./insert-media.jsx";
import { domain } from "../../helpers/variables";
import api from "../../services/api";
import "./edit-article.scss";

export const EditArticle = ({ match }) => {
  const id = parseInt(match.params.id);

  const [formData, setFormData] = useState({});
  const [formValided, setFormValided] = useState(true);
  const [legImagem, setLegImage] = useState("");
  const [loading, setLoading] = useState(true);
  const [newImage, setNewImage] = useState(false);
  const [formSubmit, setFormSubmit] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [polls, setPolls] = useState([]);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const article = await getArticleById(id);
        const allPolls = await getPolls();
        console.log("article", article);
        setFormData(article);
        setLegImage(article.image?.leg);
        setPolls(allPolls);
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  useEffect(() => {
    const checkFildsForm =
      formData.title &&
      formData.category &&
      formData.slug &&
      formData.body &&
      (formData.image?.url || formData.image?.name) &&
      legImagem;

    setFormValided(!checkFildsForm);
  }, [formData, newImage, legImagem]);

  const handleChange = (event, type) => {
    switch (type) {
      case "body":
        return setFormData({ ...formData, body: event }); // O componente de edição do tinymce manda o texto "no lugar" do event.
      case "published":
        return setFormData({
          ...formData,
          [event.target.name]: event.target.checked,
        });
      case "hasTwitter":
        return setFormData({
          ...formData,
          params: {
            hasTwitter: event.target.checked,
          },
        });
      case "number":
        return setFormData({
          ...formData,
          [event.target.name]: Number(event.target.value),
        });
      case "removeImage":
        setFormData({ ...formData, image: null });
        return setNewImage(true);
      case "addImage":
        setFormData({ ...formData, image: event.target.files[0] });
        return setNewImage(true);
      case "legImage":
        return setLegImage(event.target.value.replace(/\"/gi, "'"));
      default: {
        setFormData({ ...formData, [event.target.name]: event.target.value });
      }
    }
  };

  const saveArticle = (formData) => {
    console.log("formData", formData);

    api
      .post(`/articles/updateArticle`, formData)
      .then((response) => {
        console.log("artigo atualizado com sucesso!", response);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
        setFormSubmit(false);
        setFormSuccess(true);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setFormSubmit(true);

    if (legImagem) {
      formData.image.leg = legImagem;
    }

    console.log("formData", formData);

    if (formData.published && !formData.params?.wasPublished) {
      formData.params = {
        ...formData.params,
        wasPublished: true,
      };
    }

    if (newImage) {
      console.log("entrou no editar da imagem");

      const axiosForm = new FormData();
      axiosForm.append("file", formData.image);

      api
        .post(`/upload/articles`, axiosForm)
        .then((response) => {
          console.log("response in front", response);

          const { name, date, width, height } = response.data.content;

          formData.image = {
            url: `${date}/${name}`,
            mobile: `${date}/300-${name}`,
            lg: `${date}/lg-${name}`,
            xs: `${date}/xs-${name}`,
            width,
            height,
            leg: legImagem,
          };

          saveArticle(formData);
        })
        .catch((e) => console.log(e));
    } else {
      console.log("não vai editar a imagem");
      saveArticle(formData);
    }
  };

  const AsideMenu = () => (
    <div className="aside-menu">
      <div>
        <strong>Acessos: {formData.views}</strong>
      </div>
      <div style={{ margin: "20px 0" }}>
        <FormControl>
          <InputLabel id="category">Categoria</InputLabel>
          <Select
            value={formData.category}
            labelId="category"
            name="category"
            onChange={(e) => handleChange(e, "number")}
            style={{ minWidth: "150px" }}
          >
            {Categorys.map(({ id, title }) => (
              <MenuItem key={id} value={id}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      {polls && (
        <div style={{ margin: "20px 0" }}>
          <FormControl>
            <InputLabel id="polls">Enquete</InputLabel>
            <Select
              value={formData.polls ?? ''}
              labelId="polls"
              name="polls"
              onChange={handleChange}
              style={{ width: "150px" }}
            >
              <MenuItem value={null}>Remover</MenuItem>
              {polls.map(({ id, title }) => (
                <MenuItem key={id} value={id}>
                  {title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      )}
      <div style={{ margin: "20px 0" }}>
        <FormControl>
          <InputLabel id="author">Autor</InputLabel>
          <Select
            value={formData.author}
            labelId="author"
            name="author"
            onChange={handleChange}
            style={{ minWidth: "150px" }}
          >
            {Users.map(({ name, id }) => (
              <MenuItem key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="insert-medias" style={{ marginTop: "40px" }}>
        <InsertMedia />
      </div>
    </div>
  );

  return (
    <Layout>
      <div className="main">
        <h1>Editar artigo</h1>
        {loading ? (
          <Spinner />
        ) : (
          <Paper>
            <div className="container-form">
              {formData.id ? (
                <>
                  <form
                    noValidate
                    autoComplete="off"
                    className="container-form__editor"
                  >
                    <Grid container>
                      <Grid item md={12}>
                        <TextField
                          onChange={handleChange}
                          value={formData.title}
                          name="title"
                          label="Título"
                          fullWidth
                        />
                      </Grid>

                      {formData.slug && (
                        <Grid item md={12}>
                          <small style={{ marginTop: "5px", color: "#555" }}>
                            <strong>url:</strong> {formData.slug} |{" "}
                            <a
                              href={`${domain}/noticia/${formData.id}-${
                                formData.slug
                              }`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              ver artigo
                            </a>
                          </small>
                        </Grid>
                      )}
                      <Grid item md={12} style={{ marginTop: "20px" }}>
                        <TextField
                          onChange={handleChange}
                          value={formData.tags}
                          name="tags"
                          label="Tags"
                          placeholder="Tag1, Tag 2, Tag3"
                          fullWidth
                        />
                      </Grid>
                      <Grid container style={{ marginTop: "20px" }}>
                        <Grid item md={3}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                color="primary"
                                checked={formData.params?.hasTwitter}
                                onChange={(e) => handleChange(e, "hasTwitter")}
                                name="hasTwitter"
                                inputProps={{
                                  "aria-label": "primary checkbox",
                                }}
                              />
                            }
                            label="Twitter?"
                          />
                        </Grid>
                        <Grid item>
                          <TextField
                            type="number"
                            onChange={(e) => handleChange(e, "number")}
                            value={formData.position}
                            id="position"
                            name="position"
                            placeholder="Ordenação na home"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <div className="document-editor">
                      <Editor
                        onEditorChange={(e) => handleChange(e, "body")}
                        apiKey="labhckk4oogkv39jc30amcd8ajf692s86ws5f8h0nkvssh8c"
                        value={formData.body}
                        init={{
                          selector: "textarea",
                          menubar: false,
                          relative_urls: false,
                          autosave_interval: "10s",
                          autosave_retention: "2m",
                          autosave_prefix: "{path}",
                          convert_urls: false,
                          remove_script_host: false,
                          entity_encoding: "raw",
                          browser_spellcheck: true,
                          spellchecker_language: "pt-BR",
                          width: 650,
                          height: 720,
                          cleanup: true,
                          plugins:
                            "code media link emoticons wordcount lists autosave",
                          valid_elements:
                            "p,em,strong,figure,figcaption,strong,blockquote[*],div[*],picture[*],source[*],a[*],img[*],amp-img[*],amp-iframe[*],amp-youtube[*],amp-twitter[*],amp-instagram[*],iframe[*],ul,ol,li,h3,h4",
                          toolbar:
                            "undo redo | formatselect | code link | bold italic | numlist bullist | emoticons | restoredraft",
                          resize: false,
                          content_style: "img {width: 100%}",
                        }}
                      />
                    </div>
                    <div>
                      <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id="upload-image"
                        name="image"
                        multiple
                        type="file"
                        onChange={(e) => handleChange(e, "addImage")}
                      />
                      {formData.image?.url ? (
                        <>
                          <div
                            style={{
                              width: "100%",
                              textAlign: "center",
                              border: "1px solid #ddd",
                              padding: "4px",
                            }}
                          >
                            <img
                              style={{ maxWidth: "400px" }}
                              src={`https://static.diario24horas.com.br/images/articles/${
                                formData.image.url
                              }`}
                              alt={formData.title}
                            />
                          </div>
                          <Button
                            onClick={(e) => handleChange(e, "removeImage")}
                            variant="contained"
                            style={{ margin: "-60px 10px 0 0" }}
                          >
                            Deletar imagem <DeleteIcon color="secondary" />
                          </Button>
                        </>
                      ) : (
                        <>
                          {formData.image?.name ? (
                            <label htmlFor="upload-image">
                              <Button component="span">
                                <CloudUploadIcon color="primary" />
                                <span style={{ marginLeft: "6px" }}>
                                  Atualizar foto
                                </span>
                              </Button>
                              <span className="MuiButtonBase-root MuiButton-root MuiButton-text">
                                <CheckCircleIcon
                                  disabled={true}
                                  color="primary"
                                  style={{ marginLeft: "20px" }}
                                />
                                <small style={{ marginLeft: "6px" }}>
                                  title: {formData.image?.name}
                                </small>
                              </span>
                            </label>
                          ) : (
                            <label htmlFor="upload-image">
                              <Button component="a">
                                <CloudUploadIcon color="primary" />
                                <span style={{ marginLeft: "6px" }}>
                                  Enviar foto
                                </span>
                              </Button>
                            </label>
                          )}
                        </>
                      )}
                      <TextField
                        disabled={!formData.image && !formData.newImage}
                        value={legImagem}
                        onChange={(e) => handleChange(e, "legImage")}
                        placeholder="Legenda da imagem"
                        style={{ minWidth: "600px", margin: "20px 0" }}
                      />
                    </div>

                    <Grid container justify="center" spacing={5}>
                      <Grid item xs={12}>
                        {formSubmit && (
                          <div className="spinner">
                            <CircularProgress />
                          </div>
                        )}
                        {formSuccess && (
                          <h3 style={{ padding: "30px", textAlign: "center" }}>
                            Artigo atualizado com sucesso!
                            <strong>
                              <a
                                href={`${domain}/noticia/${formData.id}-${
                                  formData.slug
                                }`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                ver no site
                              </a>
                            </strong>
                          </h3>
                        )}
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Checkbox
                              onChange={(e) => handleChange(e, "published")}
                              checked={Boolean(formData.published) ?? false}
                              disabled={formValided}
                              value="checkedB"
                              color="primary"
                              name="published"
                            />
                          }
                          label="Publicar?"
                        />
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          onClick={handleSubmit}
                          disabled={formSubmit}
                          color="primary"
                        >
                          Atualizar artigo
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                  <AsideMenu />
                </>
              ) : (
                <div>Erro ao carregar o artigo.</div>
              )}
            </div>
          </Paper>
        )}
      </div>
    </Layout>
  );
};

export default EditArticle;
